import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from '@mui/material';
import { WebPushCampaignResponse } from '../../../sic-lib/api/webPush/types/webPush';

interface Props {
    sendWebPushResult: WebPushCampaignResponse;
    onCloseHandler: () => void;
    isOpen: boolean;
}

export default function SendWebPushResultDialog({
    sendWebPushResult,
    onCloseHandler,
    isOpen,
}: Props) {
    return (
        <Dialog
            onClose={onCloseHandler}
            open={isOpen}
            maxWidth="xs"
            aria-labelledby="dialog_web_push_result"
        >
            <DialogTitle>Web Push Result</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={1}>
                    {sendWebPushResult.message && (
                        <Grid
                            container
                            item
                            direction="row"
                            alignItems="center"
                            justifyContent="flex-start"
                        >
                            <Typography component="p" variant="caption">
                                Message:&nbsp;
                            </Typography>
                            <Typography component="p" variant="body1">
                                {sendWebPushResult?.message}
                            </Typography>
                        </Grid>
                    )}
                    <Grid
                        container
                        item
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-start"
                    >
                        <Typography component="p" variant="caption">
                            Web Push Sent:&nbsp;
                        </Typography>
                        <Typography component="p" variant="body1">
                            {sendWebPushResult?.sent}
                        </Typography>
                    </Grid>
                    <Grid
                        container
                        item
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-start"
                    >
                        <Typography component="p" variant="caption">
                            Subscriptions:&nbsp;
                        </Typography>
                        <Typography component="p" variant="body1">
                            {sendWebPushResult?.subscriptions}
                        </Typography>
                    </Grid>
                    <Grid
                        container
                        item
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-start"
                    >
                        <Typography component="p" variant="caption">
                            Failed:&nbsp;
                        </Typography>
                        <Typography component="p" variant="body1">
                            {sendWebPushResult?.failed}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseHandler}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
